var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrownPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "plus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    className: "checkmark__icon",
    "data-name": "Path 1",
    d: "M15.375,7.375H8.625V.625a.625.625,0,1,0-1.25,0v6.75H.625a.625.625,0,1,0,0,1.25h6.75v6.75a.625.625,0,0,0,1.25,0V8.625h6.75a.625.625,0,0,0,0-1.25Z",
    transform: "translate(0 0)",
    fill: "#74613C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrownPlus);
export default __webpack_public_path__ + "static/media/BrownPlus.3ec3a2a83c56cca923a41f4bacff30c5.svg";
export { ForwardRef as ReactComponent };